import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private gtagReady = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) { }

  init(): Promise<void> {
    return new Promise((resolve) => {
      if (!isPlatformBrowser(this.platformId) || !environment.production) return resolve();

      if (this.document.getElementById('gtag-script')) {
        this.gtagReady = true;
        return resolve();
      }

      const script = this.document.createElement('script');
      script.id = 'gtag-script';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsId}`;
      script.onload = () => {
        (window as any).dataLayer = (window as any).dataLayer || [];
        function gtag(...args: any[]) {
          (window as any).dataLayer.push(args);
        }
        (window as any).gtag = gtag;
        gtag('js', new Date());
        this.gtagReady = true;
        resolve();
      };
      this.document.head.appendChild(script);
    });
  }

  sendPageView(path: string) {
    if (!this.gtagReady) return;
    (window as any).gtag('config', environment.googleAnalyticsId, { page_path: path });
  }
}
